import AppConstants from '../config/app.constants';

let AtmCodesManagementService = function ($http, $q) {

    let getVaultDateRoutes = (branch, vaultDate) => {
        return $http
            .post(AppConstants.api + `/atm-codes-management/vault-date-routes`, {
                branch,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    }

    let getRouteLocation = (selectedDay, selectedRoute, branchId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/atm-codes-management/get-route-location`, {
                selectedDay,
                selectedRoute,
                branchId,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    }

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/atm-codes-management/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let autoOpenLocks = (routeId, branchId, vaultDate, isAutoOpenATMs, messengerId, performedById) => {
        return $http
            .post(AppConstants.api + `/atm-codes-management/auto-open-locks`, {
                routeId,
                branchId,
                vaultDate,
                isAutoOpenATMs,
                messengerId, 
                performedById
            })
            .then((res) => {
                return res.data
            })
    }

    let getLockStatus = (routeId, branchId, vaultDate, isAutoOpenATMs) => {
        return $http
            .post(AppConstants.api + `/atm-codes-management/get-lock-status`, {
                routeId,
                branchId,
                vaultDate,
                isAutoOpenATMs
            })
            .then((res) => {
                return res.data
            })
    }

    let removeCharacter = (message) => {
        if (!message) return message;
        return message.replace(/&quot;/g, '');
    }

    let autoOpenATMLocksProgress = (routeId, vaultDate, messengerId) => {
        return $http
            .get(AppConstants.api + `/atm-codes-management/auto-open-atm-locks-progress`, {
                params: { routeId, vaultDate, messengerId }
            })
            .then((res) => {
                return res.data
            })
    }

    let reassignLock = (lockType, toKeyId, locationId, company, performedById, routeId, messengerId, vaultDate, branchId) => {
        return $http
            .post(AppConstants.api + `/atm-codes-management/reassign-lock`, {
                lockType, toKeyId, locationId, company, performedById, routeId, messengerId, vaultDate, branchId
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        getVaultDateRoutes,
        getRouteLocation,
        create,
        autoOpenLocks,
        getLockStatus,
        removeCharacter,
        autoOpenATMLocksProgress,
        reassignLock
    };
};

AtmCodesManagementService.$inject = ['$http', '$q']

export default AtmCodesManagementService;


// WEBPACK FOOTER //
// ./client/app/services/atm-codes-management.service.js